export enum EPassForm {
  AUTH_PROVIDER = "authenticationProvider",
  SCHEME_PROVIDER = "schemeProvider",
  CURRENT_PASS = "currentPassword",
  NEW_PASS = "newPassword",
  CONFIRM_PASS = "confirmPassword",
}
